<template>
	<v-container grid-list-xs>
		<v-layout row wrap>
			<v-flex xs12 class="py-2">
				<filter-reservation
					v-model="filter"
					:outlets="outlets"
					:customers="customers"
					@filter="onFilter()"
				></filter-reservation>
			</v-flex>
			<v-flex xs12>
				<app-datatable
					:title="$t('title.reservation_datatable')"
					:printUrl="
						$route('central.reservations.print.reservations', {
							'filter[status]': this.filter.status,
							'filter[code]': this.filter.code,
							'filter[outlet_id]': this.filter.outlet_id,
							'filter[customer_id]': this.filter.customer_id,
							'filter[range]': this.filter.range,
						})
					"
					:exportUrl="
						$route('central.reservations.export.reservation', {
							'filter[status]': this.filter.status,
							'filter[code]': this.filter.code,
							'filter[outlet_id]': this.filter.outlet_id,
							'filter[customer_id]': this.filter.customer_id,
							'filter[range]': this.filter.range,
						})
					"
					:endpoint="endpoint"
					:data="data"
					:headers="headers"
					:filter="filter"
					@onView="viewItem"
					:hasDelete="false"
					:hasPrint="false"
					:hasEdit="false"
					groupBy="shift_name"
				>
					<template v-slot:[`item.status`]="{ item }">
						<v-chip :color="item.status_color" dark small>
							{{ item.status_label }}
						</v-chip>
					</template>
					<template v-slot:[`item.customer_info`]="{ item }">
						{{ item.customer_name }} <br />
						<small>{{ item.customer_phone }}</small>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>
		<app-create-fab-button
			@click="$inertia.visit($route('central.reservations.create'))"
		></app-create-fab-button>
	</v-container>
</template>
<script>
import moment from "moment";
import { Link } from "@inertiajs/inertia-vue";
import pickBy from "lodash/pickBy";
export default {
	props: ["data", "customers", "outlets"],
	data() {
		return {
			panel: [0],
			item: {},
			filter: {
				range: {
					startDate: new moment().format("YYYY-MM-DD"),
					endDate: new moment().format("YYYY-MM-DD"),
				},
			},
		};
	},
	components: {
		Link,
	},
	computed: {
		endpoint() {
			return this.$route("central.reservations.index");
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					width: 80,
					align: "left",
					sortable: false,
				},
				{
					text: this.$t("Status"),
					value: "status",
					sortable: false,
					searchable: false,
					width: 100,
				},
				{
					text: this.$t("Code"),
					value: "code",
					width: 80,
					align: "left",
					sortable: false,
				},
				{
					text: this.$t("Customer"),
					value: "customer_info",
					align: "start",
					sortable: false,
					width: 150,
				},
				{
					text: this.$t("Outlet"),
					value: "outlet_name",
					align: "start",
					sortable: false,
					width: 150,
				},
				{
					text: this.$t("Date"),
					value: "date",
					align: "start",
					sortable: false,
					width: 160,
				},
				{
					text: this.$t("Time"),
					value: "time",
					sortable: false,
					searchable: false,
					with: 150,
				},
				{
					text: this.$t("Adults"),
					value: "adults",
					align: "start",
					sortable: false,
					searchable: false,
					with: 150,
				},
				{
					text: this.$t("children"),
					value: "children",
					sortable: false,
					searchable: false,
					align: "start",
					width: 150,
				},
				{
					text: this.$t("Comment"),
					value: "description",
					sortable: false,
					searchable: false,
					width: 250,
				},
				{
					text: this.$t("Channel"),
					value: "origin",
					sortable: false,
					searchable: false,
					width: 120,
				},
			];
		},
	},

	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},
		editItem(item) {
			this.$inertia.get(
				this.$route("central.reservations.edit", item.uuid)
			);
		},

		viewItem(item) {
			this.$inertia.get(
				this.$route("central.reservations.show", item.uuid)
			);
		},
		// deleteItem(item) {
		// 	this.item = Object.assign({}, item);
		// 	this.$refs.deleteDialog.open();
		// },
		printItem(item) {
			window.open(
				this.$route("central.reservation.print", {
					reservation: item.uuid,
				})
			);
		},
	},
	watch: {
		filter: {
			handler() {
				this.$emit("filter");
			},
			deep: true,
		},
	},
};
</script>